<template>
  <!-- <modal name="contact-information" :clickToClose="false" content-style="max-height: 100vh; overflow-y: auto;" width="100%" height="100%"> -->
  <VueFinalModal
    name="contact-information"
    v-model="showModal"
    :clickToClose="false"
    :content-style="{ maxHeight: '100vh', overflowY: 'auto' }"
    width="100%"
    height="100%"
  >
    <div
      v-bind:class="['printmap', { 'is-print': printOptionSelected }]"
      v-bind:style="{ top: `${topPosition}px` }"
    >
      <div class="emb-card">
        <!--close icon-->
        <i
          aria-label="close icon"
          class="emb_closeicon is-gray"
          @click="handleClose"
        >
        </i>
        <div class="emb-card_body">
          <template v-if="!printOptionSelected">
            <h3
              class="printmap-title"
              for="schedule visit"
            >
              {{ message.h3Message }}
            </h3>
            <p
              class="printmap-desc form-group"
              for="schedule visit"
            >
              {{ message.contactMessage }}
            </p>
          </template>
          <template v-else>
            <h3
              class="printmap-title"
              for="print map"
            >
              {{ message.printH3Message }}
            </h3>
            <p
              class="printmap-desc form-group"
              for="print map"
            >
              {{ message.dreesMessage }}
            </p>
          </template>
          <form
            @submit="submitData"
            novalidate
          >
            <div class="form-group">
              <input
                type="text"
                v-model="firstName"
                name="firstName"
                placeholder="First Name"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <input
                type="text"
                v-model="lastName"
                name="lastName"
                placeholder="Last Name"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <input
                type="email"
                v-model="email"
                name="email"
                placeholder="Email Address"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <input
                type="email"
                v-model="confirmEmail"
                name="confirm-email"
                placeholder="Confirm Email Address"
                class="form-control"
              />
            </div>

            <div
              class="form-group"
              v-if="!printOptionSelected"
            >
              <label>Desired Appointment Time: </label>
              <Calendar ref="calender" />
            </div>

            <div
              class="form-group"
              v-if="!printOptionSelected"
            >
              <select
                id="time"
                name="time"
                class="form-time-control form-control"
                v-model="selectedTimeSlot"
              >
                <option value="">Choose a time</option>
                <option
                  :value="slot"
                  v-for="(slot, idx) in timeSlots"
                  :key="idx"
                >
                  {{ slot }}
                </option>
              </select>
            </div>
            <div class="form-group sv-form">
              <textarea
                name="Comments"
                cols="30"
                rows="4"
                maxlength="255"
                :placeholder="printOptionSelected ? message.printCommentPlaceholder : message.commentPlaceholder"
                class="form-control"
                v-model="questions"
              ></textarea>
            </div>
            <div class="form-group">
              <div
                class="is-error"
                v-for="error in errors"
                v-bind:key="error"
              >
                · {{ error }}
              </div>
            </div>
            <div
              class="form-group form-check"
              v-if="!printOptionSelected"
            >
              <input
                type="checkbox"
                class="form-check-input"
                id="virtualtour"
                value="Virtual Tour"
                v-model="isVirtualTour"
              />
              <label
                class="form-check-label"
                for="virtualtour"
                >{{ message.labelForVirtualTour }}</label
              >
            </div>
            <div class="form-group form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="iamrealtor"
                value="I am A Realtor"
                v-model="isRealtor"
              />
              <label
                class="form-check-label"
                for="iamrealtor"
                >{{ message.labelForRealtor }}</label
              >
            </div>
            <div class="form-group form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="newsletter"
                value="Email marketing"
                v-model="marketingOptIn"
              />
              <label
                class="form-check-label"
                for="newsletter"
                >{{ message.labelForNewsLetter }}</label
              >
            </div>
            <div class="form-group text-center">
              <button
                class="btn"
                :disabled="loading"
              >
                Submit
                <span :class="!!loading ? 'loading' : 'icon icon-right-white-arrow'"></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { ref, reactive, toRefs, defineProps, defineEmits, onMounted } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { isMobile, isTablet } from 'mobile-device-detect';
import { apiSaveLead, apiPrintPDF } from './../../api';
import { ModalType, Settings, TimeSlots } from './../../constant';
import { LeadData, LotInfo, PrintRequest } from './../../types';
import Calendar from './../Calendar.vue';
import html2canvas from 'html2canvas';
import { apiMessages } from '../../api/message-api';

const props = defineProps<{
  printOptionSelected: boolean;
  showModal: boolean;
  neighborhoodAreaName: string;
  areaId: string;
  neighborhoodName: string;
  neighborhoodId: string;
  topPosition: number;
  legends?: string;
}>();

const { printOptionSelected, neighborhoodAreaName, areaId, neighborhoodName, neighborhoodId, topPosition, showModal, legends } = toRefs(props);
const emits = defineEmits(['closeModal', 'openModal', 'openPrintModal']);

const firstName = ref('');
const lastName = ref('');
const email = ref('');
const confirmEmail = ref('');
const questions = ref('');
const message: any = ref({});
const isRequiredMessages: any = ref({});
const marketingOptIn = ref(false);
const isRealtor = ref(false);
const isVirtualTour = ref(false);
const selectedTimeSlot = ref('');
const errors = ref<string[]>();
const loading = ref(false);
const timeSlots = TimeSlots;

const calender = ref(null as any);

const loadMessages = async () => {
  const { messages, validationMessage } = await apiMessages('ContactInformation');
  message.value = messages;
  isRequiredMessages.value = validationMessage;
};

const closeModal = (modalName) => {
  emits('closeModal', modalName);
};

const openPrintModal = () => {
  emits('openPrintModal');
};

const submitData = (e) => {
  e.preventDefault();
  loading.value = true;
  errors.value = [];
  let timer = setTimeout(async (_) => {
    await submitContactInfo(e);
    clearTimeout(timer);
  }, 1);
};

const submitContactInfo = async (e) => {
  loading.value = true;
  validateName();
  validateEmail();
  !printOptionSelected.value && validateDateTime();
  if (!errors.value?.length) {
    await submitForm();
  } else loading.value = false;
};

const validateName = () => {
  isEmptyField(firstName.value, isRequiredMessages.value.firstName);
  isNameValid(firstName.value, isRequiredMessages.value.validFirstName, 0);
  isEmptyField(lastName.value, isRequiredMessages.value.lastName);
  isNameValid(lastName.value, isRequiredMessages.value.validLastName, 2);
};

const validateEmail = () => {
  isEmptyField(email.value, isRequiredMessages.value.email);
  isEmptyField(confirmEmail.value, isRequiredMessages.value.confirmEmail);
  if (email.value && !validEmail(email.value)) {
    errors.value?.push(isRequiredMessages.value.validEmail);
  }
  if (email.value && email.value !== confirmEmail.value) {
    errors.value?.push(isRequiredMessages.value.emailMismatch);
  }
};

const validateDateTime = () => {
  if (!calender.value.date) {
    errors.value?.push(isRequiredMessages.value.requiredDate);
  }
  if (!selectedTimeSlot.value) {
    errors.value?.push(isRequiredMessages.value.requiredTime);
  }
};

const isNameValid = (field, fieldText, minimumLength) => {
  if (field && isOnlyCharacter(field, fieldText) && field.length < minimumLength) {
    errors.value?.push(isRequiredMessages.value.validLastName2);
  }
};

const isOnlyCharacter = (field, fieldText) => {
  let isValid = true;
  if (field && !/^[a-zA-Z]+$/.test(field)) {
    isValid = false;
    errors.value?.push(fieldText);
  }
  return isValid;
};

const isEmptyField = (field, fieldText) => {
  if (!field) {
    errors.value?.push(fieldText);
  }
};

const submitForm = async () => {
  try {
    const dates = !printOptionSelected.value ? calender.value.date : '';
    const leadObject: LeadData = {
      areaId: fixAreaName(neighborhoodAreaName.value),
      firstName: firstName.value,
      lastName: lastName.value,
      emailAddress: email.value,
      commentsQuestions: getCommentQuestion(dates),
      marketingOptIn: marketingOptIn.value,
      isRealtor: isRealtor.value,
      preferredVisitDates: dates,
      source: 'Sales Plat',
      timestamp: new Date(),
      leadType: 'RI: Find a New Home',
      urlRef: window.location.href,
    };
    const response = await apiSaveLead(leadObject);
    window.sessionStorage.setItem(Settings.SESSION_KEY, 'Submitted');
    handleResponse(response);
  } catch (error) {
    loading.value = false;
    errors.value = [];
    errors.value?.push(message.value.errorMessage);
  }
};

const fixAreaName = (areaName) => {
  let newAreaName = areaName;
  if (newAreaName.toLowerCase().includes('wash')) {
    newAreaName = 'Drees Washington DC';
  }
  return newAreaName;
};

const getCommentQuestion = (dates) => {
  return printOptionSelected.value ? questions.value : getCommentQuestionByDates(dates);
};

const getCommentQuestionByDates = (dates) => {
  let commentString = `Want to visit ${dates} ${selectedTimeSlot.value}`;
  if (questions.value) {
    commentString += ` | ${questions.value}`;
  }
  if (isVirtualTour.value) {
    commentString += ` | Virtual Tour requested`;
  }
  return commentString;
};

const clearData = () => {
  firstName.value = '';
  lastName.value = '';
  email.value = '';
  confirmEmail.value = '';
  questions.value = '';
  marketingOptIn.value = false;
  isRealtor.value = false;
  isVirtualTour.value = false;
  selectedTimeSlot.value = '';
  errors.value = [];
};

const validEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const handleResponse = (response) => {
  clearData();
  loading.value = false;
  closeModal(ModalType.CONTACT_INFO);
  if (response && printOptionSelected.value) {
    openPrintModal();
  }
};

const handleClose = () => {
  clearData();
  closeModal(ModalType.CONTACT_INFO);
};

onMounted(async () => {
  await loadMessages();
});
</script>

<style lang="scss" scoped>
::v-deep(.vfm--overlay) {
  background-color: transparent;
}

::v-deep(.vfm) {
  z-index: 1003 !important;
}

.form-time-control {
  appearance: revert;
}

.is-slider {
  height: 100%;
}

.simplebar-scrollbar:before {
  background: $light-gray !important;
}

.simplebar-track.simplebar-vertical {
  width: 8px;
}

.printmap {
  position: fixed;
  top: 150px;
  right: 80px;
  max-width: 450px;
  width: 100%;
  max-height: calc(100% - 165px);
  box-shadow: 2px 2px 20px #5d5d5d;
  margin-right: 0px;
  z-index: 1009;
  overflow: auto;
  background: $white;
  border-radius: 4px;

  @include ipad-mini {
    height: auto;
  }

  @include mobile-standard {
    max-width: calc(100% - 20px);
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 140px;
  }

  &-title {
    font-size: 18px;
    color: $lime-green-new;

    @include md {
      @include font(21px, 600);
    }
  }

  &-desc {
    font-size: 15px;
    color: $gray;
    line-height: 20px;

    @include mobile-standard {
      font-size: 12px;
      line-height: 16px;
    }
  }

  .sv-form textarea {
    max-height: 60px;
    background-color: $white;
    border-color: #d8d8d8;

    @include mobile-standard {
      max-height: 79px;
    }
  }

  textarea {
    height: 98px;
    max-height: 98px;
  }

  .simplebar-mask,
  .simplebar-content-wrapper {
    overflow: initial !important;
  }
}

.form-check {
  margin-bottom: 10px;
  display: flex;

  @include mobile-standard {
    font-size: 11px;
    line-height: 20px;
    margin-bottom: 7px;
  }
}

.text-center {
  text-align: center;
}

.btn {
  margin: 0 auto;

  @include mobile-standard {
    min-height: 35px;
    padding: 4px 13px;
    min-width: 138px;
  }
}

.form-group:last-child {
  margin-bottom: 0;
}

.calendar {
  display: flex;
  margin-bottom: 10px;
}

.loading {
  height: 0;
  width: 0;
  padding: 6px;
  border: 4px solid #ccc;
  border-right-color: #888;
  border-radius: 22px;
  -webkit-animation: rotate 1s infinite linear;
  margin-left: 5px;
}

@-webkit-keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@media (min-width: 1400px) {
  .is-print {
    max-height: 540px;
  }
}
</style>
